<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        slot="header"
        :title="displayTitle"
        :language="getLanguage"
      />

      <div slot="content">
        <payment-view
          :payment="getPaymentData"
          :recipient="getRecipientData"
        />

        <div :class="$style.footer">
          <link-button :href="getSuccessUrl">
            {{ $t('common.proceed') }}
          </link-button>

          <p :class="$style.contact">
            {{ $t('contact.the.recipient') }} —

            <base-link :href="getProjectUrl" target="_blank">
              {{ getDisplayProjectName }}
            </base-link>
          </p>
        </div>
      </div>
    </payment-template>

    <div v-if="analyticsCode" v-html="analyticsCode"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import HTTPService from '@/services/Http';
// import logrocket from '@/services/logrocket';

import BaseLink from 'atoms/base/BaseLink';
import LinkButton from 'molecules/common/LinkButton';
import BaseHeader from 'organisms/base/BaseHeader';
import PaymentView from 'organisms/payment/PaymentView';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'PaidPayment',
  components: {
    BaseLink,
    LinkButton,
    BaseHeader,
    PaymentView,
    PaymentTemplate,
  },
  created() {
    this.loadAnalytics();
  },
  data() {
    return {
      analyticsCode: null,
    };
  },
  computed: {
    displayTitle() {
      if (this.getSubscription) {
        return this.$t('common.subscribed');
      }

      return this.$t('common.success');
    },
    getPaymentData() {
      return {
        id: this.getDisplayPaymentId,
        amount: this.getDisplayAmount,
        date: this.getFormattedPaymentDate,
        subscription: this.getSubscription,
        processToken: this.TRANSACTION.processToken,
      };
    },
    getRecipientData() {
      return {
        project: {
          name: this.getDisplayProjectName,
          url: this.getProjectUrl,
        },
        merchant: {
          email: this.getDisplayMerchantEmail,
        },
      };
    },
    ...mapState([
      'TRANSACTION',
    ]),
    ...mapGetters([
      'getLanguage',
      'getSuccessUrl',
      'getSubscription',
      'getDisplayPaymentId',
      'getFormattedPaymentDate',
      'getDisplayAmount',
      'getDisplayProjectName',
      'getDisplayMerchantEmail',
      'getProjectCode',
      'getProjectUrl',
    ]),
  },
  methods: {
    async loadAnalytics() {
      try {
        const { data } = await HTTPService.getProjectAnalytics(this.getProjectCode);

        if (data.status !== 'ACTIVE') {
          return;
        }

        this.analyticsCode = data.code;
      } catch (error) {
        // logrocket.logger(error);
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +success-overlay

  .footer
    margin-top: 20px

    +respond-to(medium)
      margin-top: 15px

  .contact
    +font-type(regular, 11, 15)
    color: var(--color-grey-2)
    margin-top: 30px

    +respond-to(medium)
    margin-top: 20px
</style>
